import {
  usePauseShopsPiiBackfill,
  useStartShopsPiiBackfill,
} from "@/api/pii-vault/use-pii-backfill";
import {
  DEFAULT_ORDER_WINDOW,
  DEFAULT_PARALLELISM,
  OrderWindowSelect,
  orderMonthsOf,
  ParallelismInput,
} from "@/components/pii-backfill/backfill-settings";
import { Button } from "@babackapp/ui/components/button";
import { Pause, Play } from "lucide-react";
import { useState } from "react";

/** Starts or pauses the selected shops with one set of run settings. */
export function PiiBackfillLaunchBar({ shopIds }: { shopIds: string[] }) {
  const start = useStartShopsPiiBackfill();
  const pause = usePauseShopsPiiBackfill();
  const [orderWindow, setOrderWindow] = useState(DEFAULT_ORDER_WINDOW);
  const [parallelism, setParallelism] = useState(DEFAULT_PARALLELISM);
  const isEmpty = shopIds.length === 0;

  return (
    <div className="flex flex-wrap items-center gap-2 rounded-lg border bg-muted/30 p-3">
      <OrderWindowSelect value={orderWindow} onChange={setOrderWindow} />
      <ParallelismInput value={parallelism} onChange={setParallelism} />
      <Button
        size="sm"
        disabled={isEmpty || start.isPending}
        onClick={() =>
          start.mutate({
            body: {
              shopIds,
              parallelism,
              orderMonths: orderMonthsOf(orderWindow),
            },
          })
        }
      >
        <Play className="w-4 h-4" />
        Lancer {shopIds.length} shop(s)
      </Button>
      <Button
        size="sm"
        variant="secondary"
        disabled={isEmpty || pause.isPending}
        onClick={() => pause.mutate({ body: { shopIds } })}
      >
        <Pause className="w-4 h-4" />
        Pause
      </Button>
      <p className="text-xs text-muted-foreground">
        Les shops lancés ensemble se partagent la même file : plus il y en a,
        plus chacun avance lentement. Un shop déjà terminé n'est relancé que si
        la fenêtre des commandes s'élargit.
      </p>
    </div>
  );
}
